/* split-test vgrid_inf_scroll_v3 */

import './vertical-grid.css';

import './img/blank.png';
